import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Container = styled.div`
  margin-bottom: 33px;
`

export const StyledFormikInputField = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 0.5625rem;
  input {
    height: 38px;
    letter-spacing: 0.57px;
    line-height: 19px;
    color: ${themeGet('colors.black')};
    border: 1px solid ${themeGet('colors.gray1000')};
    padding: 11.25px 15px 13.75px;
  }
  input:disabled {
    background-color: ${themeGet('colors.white100')};
  }
  input:focus {
    border: 1px solid ${themeGet('colors.darkBlue')};
    outline: ${themeGet('colors.darkBlue')};
  }
  :last-child {
    margin-bottom: 0;
  }
`
export const InputLabel = styled.label`
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('textFontFamilySemibold')};
  margin-bottom: 0.375rem;
  line-height: 24px;
`
